__webpack_require__.p = "/jo/en/customer-service/returns-claims/spareparts/";